<template>
    <div class="SystemItemsGroup">
        <h3 class="group-header">{{ group.name }}</h3>
        <div class="systems-journeys-wrapper">
            <SystemItem
                v-for="(journey, index) in group.journeys"
                :key="journey.name"
                :journey="journey"
                :index="index"
                :has-system-games="false"
                :system-id="systemId"
                :group-name="group.name"
            />
        </div>
    </div>
</template>

<script>
import SystemItem from './SystemItem';

export default {
    components: {
        SystemItem
    },

    props: {
        group: {
            type: Object,
            required: true,
            default: () => {}
        },

        systemId: {
            type: String,
            required: true,
            default: ''
        }
    }
};
</script>

<style lang="scss" scoped>
.SystemItemsGroup {
    .group-header {
        font-size: 18px;
        width: 100%;
        color: #151515;
        margin-bottom: 2em;
    }

    .systems-journeys-wrapper {
        box-shadow: 0px 2px 23px 3px rgba(79, 79, 79, 0.1);
        border-radius: 4px;
        .SystemItem {
            margin-top: 0;
            box-shadow: none;
        }
    }
}
</style>
